<script>
import { connect } from 'vuex-connect';
import AdBox from '../scenes/AdBox.vue';

const panelFactory = (side) => connect({
  gettersToProps: {
    banners: `banners${side}`, // MOCK
  },
})('AdBox', AdBox);
const panels = {
  left: panelFactory('Left'),
  right: panelFactory('Right'),
};

export default {
  functional: true,
  render (h, { data, props }) {
    return h(panels[props.side], data);
  },
};
</script>
